import script from "./Services.vue?vue&type=script&setup=true&lang=ts"
export * from "./Services.vue?vue&type=script&setup=true&lang=ts"

import "./Services.vue?vue&type=style&index=0&id=44621604&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44621604"]])

export default __exports__